<template>
    <v-app>    
        <v-main>
            <v-container 
                class="fill-height justify-center" 
                fluid
            >
                <v-row 
                    justify="center" 
                    style="z-index:10"
                    class="my-auto"
                >
                    <v-col class="d-flex justify-center">
                        <v-card class="d-flex elevation-6"> 
                            <v-card
                                width="400"
                                flat
                                rounded="0"
                                class="d-flex justify-center align-center px-8"
                            >
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <div class="mb-6">Enter your credentials to sign in</div>
                                        <v-window v-model="step">
                                            <v-window-item
                                                :value="1"
                                                transition="slide-x-transition"
                                            >
                                                <div class="p4" v-if="getloginErrors">
                                                    <v-alert
                                                        type="error"
                                                        outlined
                                                        class="red--text"
                                                    >
                                                        <div>{{ getloginErrors }}</div>
                                                    </v-alert>
                                                </div>

                                                <v-card-text>
                                                    <div class="primary--text text-h5 text-left">
                                                        <v-text-field
                                                            label="Student ID"
                                                            placeholder="Enter student ID"
                                                            name="id"
                                                            type="text"
                                                            color="primary"
                                                            v-model="formData.student_id"
                                                            clearable
                                                            autofocus
                                                            class="mt-4"
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                color="primary"
                                                            >
                                                                mdi-account
                                                            </v-icon>
                                                        </v-text-field>
                                                        <div class="text-right mt-8">
                                                            <v-btn
                                                                color="primary"
                                                                @click="nextStep"
                                                                dark
                                                                block
                                                            >
                                                                NEXT
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                </v-card-text>
                                            </v-window-item>

                                            <v-window-item
                                                :value="2"
                                                transition="slide-x-transition"
                                            >
                                                <div class="pa-4">
                                                    <v-alert
                                                        type="error"
                                                        outlined
                                                        v-if="getloginErrors"
                                                        class="red--text"
                                                    >
                                                        {{ getloginErrors }}
                                                    </v-alert>
                                                </div>

                                                <v-text-field
                                                    v-show="password"
                                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                    label="Birth Certificate Pin"
                                                    placeholder="Enter Birth Certificate Pin"
                                                    @click:append="show = !show"
                                                    name="password"
                                                    v-model="formData.password"
                                                    clearable
                                                    autofocus
                                                    class="mt-4"
                                                >
                                                    <v-icon
                                                        slot="prepend"
                                                        color="primary"
                                                    >
                                                        mid-key
                                                    </v-icon>
                                                </v-text-field>

                                                <div class="text-right mt-8">
                                                    <v-btn
                                                        color="primary"
                                                        @click="submit"
                                                        dark
                                                        block
                                                    >
                                                        LOGIN
                                                    </v-btn>
                                                </div>

                                            </v-window-item>
                                        </v-window>
                                    </v-col>
                                </v-row>
                            </v-card>

                            <v-card 
                                width="340"
                                height="350"
                                class="px-8 d-flex align-center justify-center flex-column"
                                color="primary"
                                flat
                                rounded="0"
                                style="position:relative;"
                            >
                                
                                <v-img
                                    src="../../assets/logo.png"
                                    max-width="120"
                                    contain
                                    class="d-flex"
                                    style="position: absolute; top: -70px;"
                                ></v-img>

                                <div class="d-sm-none d-flex justify-center flex-column align-center" style="position: relative; height: 100%;">
                                    <div class="text-center font-weight-light white--text mb-6">Welcome to:</div>
                                    <div class="text-center white--text mb-4" style="font-size:0.7rem;  text-transform: uppercase;">{{ schoolName }}</div>
                                    <div class="font-weight-black text-center accent--text" style="font-size:1rem; transform:scaleY(1.5);">STUDENT E-REPORT</div>  

                                    <v-img
                                        src="../../assets/result.png"
                                        max-width="20"
                                        contain
                                        style="position: absolute; bottom: 20px;"
                                    ></v-img>
                                </div>
                                    
                                <div class="d-none d-md-flex flex-column justify-center align-center">

                                    <div class="text-center font-weight-light white--text mb-6">Welcome to:</div>
                                    <div class="text-center white--text" style="font-size:0.8rem; text-transform: uppercase;">{{ schoolName }}</div>
                                    <div class="font-weight-black text-center accent--text" style="font-size:1.5rem; transform:scaleY(1.5);">STUDENT E-REPORT</div>  

                                    <v-img
                                        src="../../assets/result.png"
                                        max-width="50"
                                        contain
                                        style="position: absolute; bottom: 20px;"
                                    ></v-img>
                                </div>

                               
                            </v-card>
                        </v-card>

                       
                    </v-col>
                </v-row>

                <v-overlay
                    :value="getOverlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>

            </v-container>            
        </v-main>
        
    </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Login',
    components: {
        //
    },
    data(){
        return {
            show: false,
            userpassword: '',
            formData: {
                student_id: '',
                password: '',
            },
            password: true,
            step: 1,
        }
    },         
    props: {
        source: String,
    },
    watch: {
        userpassword: {
            handler(val){
                this.formData.student_id = val;                
            }
        },              
    },
    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'form/getSchoolName',            
            getloginErrors: 'auth/getLoginErrors',
            getAuthenticated: 'auth/getAuthenticated',
        }),       
        
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            user: 'auth/user',
        }),

        ...mapMutations({
            setOverlay: 'auth/setOverlay',
            setUserId: 'auth/setUserId',
        }),

        nextStep () {
            this.step++;
        },
        async submit () {
            this.setUserId(this.formData.student_id);
            await this.signIn(this.formData);
            if(!this.getAuthenticated){
                this.loginErrors = this.getLoginErrors 
                return;
            }
            this.$router.replace('/term-report');
            this.setOverlay(false);
                                                           
        },
        
        
    }
}
</script>

<style scoped>
   

</style>